import { type CopyExperimentParams } from "@bookingcom/lingojs-experiments";
import { type UIPointOfSale } from "@flights/types";

export const getCopyExperimentParamsClient = (ipCountry?: UIPointOfSale, isMobile?: boolean): CopyExperimentParams => {
  const countries = !!ipCountry ? [String(ipCountry)] : undefined;
  const siteTypesArr: CopyExperimentParams["siteTypes"] = [];
  if (!isMobile) siteTypesArr.push("www");
  if (!!isMobile) siteTypesArr.push("mdot");
  const siteTypes = siteTypesArr.length ? siteTypesArr : undefined;
  return { countries, siteTypes };
};
